/** Parses a possibly-empty/garbled CSV cell into a finite number, or undefined. */
export function toNum(value: string | undefined | null): number | undefined {
  if (value === undefined || value === null) return undefined;
  const trimmed = value.trim();
  if (trimmed === '') return undefined;
  const cleaned = trimmed.replace(/[$,%]/g, '');
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : undefined;
}

export function pctChange(current?: number, previous?: number): number | undefined {
  if (current === undefined || previous === undefined || previous === 0) return undefined;
  return ((current - previous) / previous) * 100;
}

export function round(value: number, decimals = 1): number {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

export function mean(values: number[]): number | undefined {
  const valid = values.filter((v) => Number.isFinite(v));
  if (valid.length === 0) return undefined;
  return valid.reduce((a, b) => a + b, 0) / valid.length;
}

export function stddev(values: number[]): number | undefined {
  const valid = values.filter((v) => Number.isFinite(v));
  if (valid.length < 2) return undefined;
  const m = mean(valid)!;
  const variance = valid.reduce((acc, v) => acc + (v - m) ** 2, 0) / (valid.length - 1);
  return Math.sqrt(variance);
}

/** Standard z-score normalization; returns undefined if there isn't enough spread to compute one. */
export function zScore(value: number | undefined, populationMean?: number, populationStd?: number): number | undefined {
  if (value === undefined || populationMean === undefined || !populationStd) return undefined;
  return (value - populationMean) / populationStd;
}
